import React from "react";

import UserProfile from "../Header/UserProfile";
import classes from "./Sidebar.module.css";

export default function Sidebar(props) {
  const year = new Date().getFullYear();
  let class_name = classes.Navigation;
  if (props.extraClass) class_name += " " + classes.Second;
  let style = { display: "block" };
  if (!props.show && props.extraClass) style.display = "none";
  return (
    <nav className={class_name} style={style}>
      <ul className={classes.ListItems}>
        <li className={classes.Active_Link}>
          <i className="fas fa-home" />
          <span>Home</span>
        </li>
        <li>
          <i
            className="fas fa-fire"
            style={{ marginLeft: "2px", marginRight: "25px" }}
          />
          <span>Trending</span>
        </li>
        <li>
          <div className={classes.Youtube_Subscriptions}>
            <span />
            <span />
            <i className="fab fa-youtube" />
          </div>
          <span>Subscriptions</span>
        </li>
      </ul>
      <ul className={classes.ListItems}>
        <li>
          <i className="fas fa-folder" />
          <span>Library</span>
        </li>
        <li>
          <i className="fas fa-history" />
          <span>History</span>
        </li>
      </ul>
      <div>
        <div className={[classes.Padding, classes.Login].join(" ")}>
          Sign in to like videos, comment, and subscribe.
        </div>
        <UserProfile />
      </div>
      <div>
        <h3 className={classes.Padding}>BEST OF YOUTUBE</h3>
        <ul className={classes.ListItems}>
          <li>
            <span>
              <i className="fas fa-music" />
            </span>
            <span>Music</span>
          </li>
          <li>
            <span>
              <i className="far fa-futbol" />
            </span>
            <span>Sports</span>
          </li>
          <li>
            <span>
              <i className="fas fa-gamepad" />
            </span>
            <span>Gaming</span>
          </li>
          <li>
            <span>
              <i className="far fa-newspaper" />
            </span>
            <span>News</span>
          </li>
          <li>
            <span>
              <i className="fas fa-broadcast-tower" />
            </span>
            <span>Live</span>
          </li>
          <li>
            <span>
              <i className="fas fa-vr-cardboard" />
            </span>
            <span>360&deg; Video</span>
          </li>
        </ul>
      </div>
      <ul className={classes.ListItems}>
        <li>
          <i className="fas fa-plus-circle" />
          <span>Browse channels</span>
        </li>
      </ul>
      <div>
        <h3 className={classes.Padding}>MORE FROM YOUTUBE</h3>
        <ul className={classes.ListItems}>
          <li>
            <i className="fas fa-broadcast-tower" />
            <span>Live</span>
          </li>
        </ul>
      </div>
      <ul className={classes.ListItems}>
        <li>
          <i className="fas fa-cog" />
          <span>Setting</span>
        </li>
        <li>
          <i className="fas fa-flag" />
          <span>Report History</span>
        </li>
        <li>
          <i className="fas fa-question-circle" />
          <span>Help</span>
        </li>
        <li>
          <i className="fas fa-comment-alt" />
          <span>Send Feedback</span>
        </li>
      </ul>
      <footer className={classes.AsideFooter}>
        <ul className={classes.InlineListItems}>
          <li>About</li>
          <li>Press</li>
          <li>Copyright</li>
          <li>Contact us</li>
          <li>Creators</li>
          <li>Advertise</li>
          <li>Developers</li>
        </ul>
        <ul className={classes.InlineListItems}>
          <li>Terms</li>
          <li>Privacy</li>
          <li>Policy &amp; Safety</li>
          <li>Test new features</li>
        </ul>
        <p>&copy; {year} Youtube, LLC</p>
      </footer>
    </nav>
  );
}
